export default __webpack_public_path__ + "static/web-image-2ef07c7454bd65df7de55dce660340f7.webp";